module.exports = __webpack_public_path__ + "img/banner_5.c4fdcb60.png";